const FEATURE_TOGGLER = {
  loyalty: true,
}

module.exports = {
  FEATURE_TOGGLER,
}
